import { defineMessages } from "react-intl"

export const conditionAndServiceContainerMessages = defineMessages({
	pcssLink: {
		defaultMessage: "PCSS",
		id: "vehicleDetails.overview.history.pcssLink",
	},
	title: {
		defaultMessage: "Condition, History and Latest Maintenance",
		id: "vehicleDetails.overview.conditionHistory.header",
	},
})
